module.exports = __webpack_public_path__ + "img/comment-icon.d87cd9a2.png";